module.exports = __webpack_public_path__ + "res/tap_tap_shots.4b89bc02151bc2505197f1efe73e6c39.webp";